import { TemplateType } from "../../config/Enums";

export class AddUpdateSectionCommand {
  public Id: number = 0;
  public SiteId: string = "";
  public PageVersionId: number = 0;
  public Name: string = "";
  public ClientJSScript: string = "";
  public JSFilePath: string = "";
  public Order: number = 0;
  public Template: TemplateType = TemplateType.ColumnsCC;
  public Columns: number = 12;
  public BackgroundColour: string = "";
  public BackgroundImage: string = "";
  public SectionClass: string = "";
  public SectionHRefId: string = "";
}